const doc = [({"en":({"task":"Batch name", "aggregateDate":"Reference date", "fromDate":"Aggregation date(from)", "toDate":"Aggregation date(to)"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;